import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunButton',
    props: {
        id: null,
        full: { type: Boolean },
        title: null,
        disabled: { type: Boolean },
        version: null
    },
    setup(__props) {
        const props = __props;
        library.add(faPlay);
        const runPath = computed(() => `/workflows/run?id=${props.id}${props.version !== undefined ? `&version=${props.version}` : ""}`);
        return { __sfc: true, props, runPath, faPlay, FontAwesomeIcon, BButton };
    }
});
